import React, { useState, useEffect } from 'react';
import styles from '../styles/pages/aboutuspage.module.css';
import { MdOutlineDoubleArrow } from 'react-icons/md';
import ModalArray from '../components/ModalArray'; // Assuming ModalArray is in the components folder
import { useAuth } from "../authentication/AuthContext";
import axios from 'axios';

function FuturePlans() {
  const { isAuthenticated } = useAuth();
  const [futurePlans, setFuturePlans] = useState([]);  // State to hold the future plans
  const [loading, setLoading] = useState(true);

  // Fetch future plans from the backend API
  useEffect(() => {
    const fetchFuturePlans = async () => {
      try {
        const response = await axios.get('/api/futurePlans?label=futurePlans'); // Replace with actual URL
        if (response.data && response.data.futurePlans) {
          setFuturePlans(response.data.futurePlans);  // Store fetched future plans in state
        }
      } catch (error) {
        console.error("Error fetching future plans:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFuturePlans();
  }, []);

  // Handle sending updated futurePlans to the backend (including appending new plans)
  const postFuturePlansData = async (updatedPlans) => {
    try {
      const response = await axios.post("/api/futurePlans", {
        label: "futurePlans",  // Identifying which future plans to update
        futurePlans: updatedPlans,  // Send the updated array to backend
      });

      if (response.data && response.data.message) {
        setFuturePlans(updatedPlans);  // Update the local state with the new plans
        alert("Future plans updated successfully!");
      }
    } catch (error) {
      console.error("Error updating future plans:", error);
      alert("Failed to update future plans.");
    }
  };

  return (
    <div className="body">
      <div className="heading">
        
        FUTURE PLANS
      </div>
      <hr />
      <hr />
      {isAuthenticated && (
        <ModalArray
          onSubmit={postFuturePlansData}  // Pass the function to handle submitting future plans
          value={futurePlans}  // Pass the current future plans to the modal
          label="futurePlan"  // Label used for identifying the plans in ModalArray
        />
      )}
      <div className="body">
        <div className={`${styles.text} ${styles.future_plans} ${styles.highlight}`}>
          {loading ? (
            <p>Loading future plans...</p>
          ) : (
            futurePlans.length > 0 ? (
              futurePlans.map((plan, index) => (
                <p key={index}>
                  <MdOutlineDoubleArrow /> {plan}
                </p>
              ))
            ) : (
              <p>No future plans available at the moment.</p>
            )
          )}
        </div>
      </div>
    </div>
  );
}

export default FuturePlans;
